import { motion } from "framer-motion";
import { Card, CardHead, CardTitle, CardSub } from "./Features.styled";
import FeatureModal from "../feature-modal/FeatureModal";
import { useState } from "react";

const FeatureCard = ({ feature, idx }) => {
  const Icon = feature.icon;
  const [cardOpen, setCardOpen] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.45, delay: idx * 0.03 }}
    >
      <Card onClick={() => setCardOpen(true)}>
        <CardHead>
          <span className="icon">
            <Icon size={24} />
          </span>
          <CardTitle>{feature.title}</CardTitle>
        </CardHead>
        <CardSub>{feature.tagline}</CardSub>
      </Card>
      {cardOpen && (
        <FeatureModal feature={feature} onClose={() => setCardOpen(false)} />
      )}
    </motion.div>
  );
};

export default FeatureCard;
